import styled from 'styled-components';

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 2rem 0;
  padding-bottom: 0;
  align-items: start;
`;
